import {http} from '../config';
export default{
    listarProveedors:()=>{
        return http.get('api/proveedors');
    },
    save:(proveedor)=>{
        return http.post('api/proveedors',proveedor)
    },
   update: (proveedor) => {
  return http.put('api/proveedors/' + proveedor.id, proveedor)
},
    delete:(proveedor)=>{
        return http.delete('api/proveedors/'+proveedor.id)
    }
}
